module.exports = __webpack_public_path__ + "static/img/3.68133c6b.png";